module.exports = __webpack_public_path__ + "img/tui.97e65df9.png";